module.exports = __webpack_public_path__ + "img/hr-sand-4.115da5f1.png";